import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CrudService, MessageService, timeHash } from 'elbuild-ui-lib-core';
import { Calendar, CalendarDay, CalendarDayHeader, Employee, EmployeeService, Timesheetexception, TimesheetResponse, WEEKDAYS } from 'toolbandi-ui-lib';

import { TimesheetEditModalComponent } from './timesheet-edit-modal/timesheet-edit-modal.component';

@Component({
	selector: 'app-timesheet-grid',
	templateUrl: './timesheet-grid.component.html',
	styleUrls: ['./timesheet-grid.component.scss']
})
export class TimesheetGridComponent implements OnInit {

	@Input() employee: Employee;

	calendar: Calendar = new Calendar();
	timesheet: TimesheetResponse;
	weekDays: CalendarDayHeader[] = WEEKDAYS;

	constructor(
		private timesheetService: CrudService<Timesheetexception>,
		private employeeService: EmployeeService,
		private messageService: MessageService,
		private modalService: NgbModal,
	) {
	}

	ngOnInit() {
		this.loadTimeSheet();
	}

	today() { this.calendar = new Calendar(); }
	next() { this.calendar.next(); }
	prev() { this.calendar.prev(); }

	loadTimeSheet() {

		this.employeeService.getEmployeeTimeSheet(this.employee.id).subscribe((ts: TimesheetResponse) => {
			this.timesheet = ts;
		}, ({ error }) => {
			this.messageService.sendError(error, 'Timesheet');
		});
	}

	editWokingHours(d: CalendarDay) {
		const modal = this.modalService.open(TimesheetEditModalComponent, {
			centered: true, backdrop: 'static', keyboard: false, size: 'lg'
		});
		// invio dei dati alla modale
		modal.componentInstance.calendarDay = d;
		modal.componentInstance.title = 'edit-timesheet-day';
		modal.result.then((exception: Timesheetexception) => {
			if (exception) {
				exception.employeeid = this.employee.id;
				exception.timehash = timeHash(d.day);

				this.timesheetService.createEntity(Timesheetexception, 'timesheetexception', exception).subscribe(
					() => {
						this.messageService.sendSuccess('Orario modificato', 'Timesheet');
						this.loadTimeSheet();
					},
					({ error }) => {
						this.messageService.sendError(error, 'Timesheet');
					});
			}
		}).catch(() => { });
	}

	getCellClasses(d: CalendarDay) {
		let classes = '';
		// different month
		if (this.calendar.isDifferentMonth(d.day)) classes += 'different-month ';

		let conditionalClasses = '';

		if (this.timesheet) {
			if (this.timesheet.dateInRange(d.day)) {
				conditionalClasses = 'grid-cell-green ';
				d.workingHours = 8;
			}
			const exception: Timesheetexception = this.timesheet.dateInExceptions(d.day);
			if (exception && exception.id) {
				conditionalClasses = 'grid-cell-yellow ';
				d.workingHours = exception.hours;
				d.exception = exception;
			}
			if (this.timesheet.dateInHolidays(d.day) || this.calendar.isDayWeekend(d.day)) {
				conditionalClasses = 'grid-cell-red text-danger ';
				d.workingHours = undefined;
			}
		}

		return classes + conditionalClasses;
	}

}
